<template>
  <div class="all">
    <div class="header-top">
      <el-button type="primary" size="small" plain @click="getfreshen">
        刷新
      </el-button>
      <el-button v-if="deleCadFont" :disabled="!fileID" type="primary" size="small" plain @click="deleteBtn">
        删除
      </el-button>
      <el-button v-if="renameCadFont" :disabled="!fileID" type="primary" size="small" plain @click="renameBtn">
        重命名
      </el-button>
      <el-upload ref="upload" :disabled="upload" :show-file-list="false" :http-request="httpRequest" multiple
        accept=".shx,.SHX" class="upload-file" style="display: inline-block; margin: 0 10px" action="/">
        <el-button v-if="renauploadCadFont" type="primary" size="small" plain @click="upLoadFile">
          上传
        </el-button>
      </el-upload>
      <el-button v-if="downCadFont" :disabled="!fileID" type="primary" size="small" plain @click="download">
        下载
      </el-button>
      <el-button v-if="editCadFont" :disabled="!fileID" size="small" type="primary" plain @click="changeRemark">
        修改备注
      </el-button>
    </div>
    <div class="midd">
      <el-table ref="multipleTable" :data="tableData" border highlight-current-row height="100%" @row-click="handleDelete">
        <template slot="empty">
          <img :src="zanwu" alt="" />
          <p style="font-size: 16px; color: #000; margin-top: 36px">暂无数据</p>
        </template>
        <el-table-column label="序号" type="index" width="60" />
        <el-table-column label="文件名称" prop="fileName" min-width="200px" />
        <el-table-column label="创建人" prop="operatorName" />
        <el-table-column label="上传时间" prop="uploadTime" min-width="120px" />
        <el-table-column label="最近更新时间" prop="updateTime" min-width="120px" />
        <el-table-column label="备注" prop="remark" min-width="200px" />
      </el-table>
    </div>
    <!--修改 -->
    <el-dialog v-dialogDrag :visible.sync="editPersonDialog" :before-close="getEditPersonClose"
      :close-on-click-modal="false" :close-on-press-escape="false" title="备注" width="500px">
      <el-form ref="frameForm" :model="frameForm" size="small">
        <el-form-item label="备注:" prop="remark" style="line-height: 40px">
          <el-input v-model="frameForm.remark" :autosize="{ minRows: 2, maxRows: 6 }" type="textarea" maxlength="200" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="getEditPersonClose">取 消</el-button>
        <el-button type="primary" size="small" @click="sureChangeRemark">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import standardcadFont from "@/CommonDP/service/standardCadFont-service";
import { checkPermission, disablePrompt } from "@/CommonDP/utils/routeAuth";
import { mapState } from "vuex";
export default {
  name: "StandardCadFont",
  data() {
    return {
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      tableData: [],
      currentRow: {},
      editPersonDialog: false,
      frameForm: { remark: "" },
      fileID: undefined,
      upload: false,
      list: [],
      deleCadFont: checkPermission(this.$allPerms.STANDARDCADFONT_DALE),
      renameCadFont: checkPermission(this.$allPerms.STANDARDCADFONT_RENAME),
      renauploadCadFont: checkPermission(this.$allPerms.STANDARDCADFONT_UPLOAD),
      downCadFont: checkPermission(this.$allPerms.STANDARDCADFONT_DOWN),
      editCadFont: checkPermission(this.$allPerms.STANDARDCADFONT_EDIT)
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 上传
    upLoadFile() {
      const a = disablePrompt();
      if (!a) {
        this.upload = true;
      }
    },
    async httpRequest({ file }) {
      const data = new FormData();
      data.append("filervt", file);
      data.append("enterpriseId", this.enterpriseId);
      data.append("remark", "");
      try {
        this.upload = true;
        const res = await standardcadFont.uploadStandardCADFontFile(data);
        if (res.result === "0") this.$message.success("上传成功");
        this.getList();
      } finally {
        this.upload = false;
      }
    },
    // 列表
    getList() {
      this.tableData = [];
      standardcadFont.selectStandardCADFontMaintenance(this.enterpriseId).then(({ data }) => {
        this.tableData = data || [];
      });
    },
    // 选中的节点
    handleDelete(val) {
      this.currentRow = val;
      this.fileID = val.fileId;
    },
    // 刷新
    getfreshen() {
      this.currentRow = {};
      this.fileID = undefined;
      this.getList();
    },
    // 重命名
    renameBtn() {
      const a = disablePrompt();
      if (a) {
        const row = this.currentRow;
        const { $prompt, enterpriseId } = this;
        const reg = /\.[\w\d]+?$/;
        const reNameStr = row.fileName.replace(reg, "");
        const extName = row.fileName.slice(reNameStr.length);
        $prompt("请输入文件名称", "编辑文件名称", {
          inputPlaceholder: "输入文件名称",
          inputValue: reNameStr,
          inputErrorMessage: "请输入除空格外的100文字以内的名称",
          inputPattern: /^\S{1,100}$/,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          beforeClose: (action, { inputValue }, done) => {
            if (action === "confirm") {
              const folderForm = {
                fileName: inputValue + extName,
                fileID: row.fileId,
                enterpriseId
              };
              standardcadFont.updateStandardCADFont(folderForm).then((data) => {
                if (data.result === "0") {
                  this.$message({
                    showClose: true,
                    type: "success",
                    message: "修改成功"
                  });
                }
                this.currentRow = {};
                this.fileID = undefined;
                this.getList();
                done();
              });
            } else {
              done();
            }
          }
        });
      }
    },
    // 删除
    async deleteBtn() {
      const a = disablePrompt();
      if (a) {
        await this.$confirm("此操作将删除本行数据，是否继续？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          closeOnClickModal: false,
          closeOnPressEscape: false
        });
        const res = await standardcadFont.deleteStandardCADFont({ id: this.fileID });
        if (res.result === "0") {
          this.$message({ message: "删除成功", type: "success" });
        }
        this.currentRow = {};
        this.fileID = undefined;
        this.getList();
      }
    },
    // 下载
    async download() {
      const a = disablePrompt();
      if (a) {
        const fileID = this.fileID;
        standardcadFont.downloadStandardCADFontFile(fileID).then((response) => {
          if (response.type === "application/json") {
            const fileReader = new FileReader();
            fileReader.onloadend = () => {
              const jsonData = JSON.parse(fileReader.result);
              // 后台信息
              this.$message({ message: jsonData.message, type: "error" });
            };
            fileReader.readAsText(response); // 或者读取response.data
          } else {
            const link = document.createElement("a");
            const blob = new Blob([response], {
              type: "application/octet-stream"
            });
            link.style.display = "none";
            link.href = URL.createObjectURL(blob);
            link.setAttribute("download", decodeURI(this.currentRow.fileName));
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        });
      }
    },
    // 修改
    async changeRemark() {
      const a = disablePrompt();
      if (a) {
        this.editPersonDialog = true;
        this.frameForm.remark = this.currentRow.remark;
      }
    },
    // 修改保存
    async sureChangeRemark() {
      const {
        frameForm: { remark },
        fileID,
        enterpriseId
      } = this;
      const params = {
        remark,
        fileID,
        enterpriseId
      };
      const res = await standardcadFont.updateStandardCADFont(params);
      if (res.result === "0") {
        this.$message({
          showClose: true,
          type: "success",
          message: "修改成功"
        });
      }
      this.currentRow = {};
      this.fileID = undefined;
      this.getEditPersonClose();
    },
    getEditPersonClose() {
      this.$refs.frameForm.resetFields();
      this.editPersonDialog = false;
      this.currentRow = {};
      this.fileID = undefined;
      this.getList();
    }
  }
};
</script>
<style lang="scss" scoped>
.all {
  height: 100%;
  position: relative;
  background-color: #fff;
}
.header-top {
  position: absolute;
  top: 10px;
  left: 0;
  right: 0;
  height: 50px;
  padding: 10px;
  .header_b {
    margin-top: 10px;
    margin-left: 20px;
  }
}
.midd {
  position: absolute;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 4px 10px;
}
</style>
